// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "4f5933be7a588835bc313c26d24278fd" + ".js";
};